// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as Display$LumiDocuments from "lumi-documents/lib/es6/src/Display.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as DisplayStyle$LumiFacilityMap from "./DisplayStyle.res.js";

let empty = Belt_Map.make(Display$LumiDocuments.Schema.CmpKey);

let update = Belt_Map.update;

function merge(a, b) {
  return Belt_Map.merge(a, b, (_key, x, y) => LumiOption.unionWith(DisplayStyle$LumiFacilityMap.merge, x, y));
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let Cmp;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  Cmp,
  empty,
  update,
  merge,
}
/* empty Not a pure module */
